import { HeadProps, Script } from "gatsby";
import React from "react";
import getRichSnippet from "../util/getRichSnippet";
import useSiteMetadata from "../util/useSiteMetadata";

type Props = HeadProps<{
  title: string;
  frontmatter?: Queries.BlogPostFrontmatterFragment;
}>;

export default function SEO(props: Props) {
  const meta = useSiteMetadata(props.data);
  return (
    <>
      <title>{meta.fullTitle}</title>
      <meta name="title" property="og:title" content={meta.title} />
      <meta
        name="description"
        property="og:description"
        content={meta.description}
      />
      <meta name="image" property="og:image" content={meta.imagePath} />
      <meta
        property="og:type"
        content={props.data.frontmatter ? "article" : "website"}
      />
      <meta name="twitter:image" content={meta.imagePath} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={meta.author} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:site" content="@dolthub" />
      {props.data.frontmatter && (
        <>
          {props.data.frontmatter.date && (
            <meta
              property="article:published_time"
              content={props.data.frontmatter.date}
            />
          )}
          {props.data.frontmatter.author && (
            <meta name="author" content={props.data.frontmatter.author} />
          )}
        </>
      )}
      <Script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: getRichSnippet(meta, props.data.frontmatter),
        }}
      />
    </>
  );
}
